/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Lightbox } from 'react-modal-image';
import 'react-fancybox/lib/fancybox.css';
import defaultGallery from '../../assets/img/gallery_default.png';
import { CreateBlobUrl, hotFixCreateBlobUrl } from '../../helper/binarytoblob';
import {
  editGallery,
  fetchGalleryDetails,
  removeGallery,
} from '../../helper/galleyHelper';
import { connect } from 'react-redux';

const GalleryImage = ({
  setGalleryData,
  setGalleryImages,
  galleryData,
  galleryImages,
  blobURL,
  setBlobURL,
  member,
  setShowGalleryModal,
  setPreviewScreen,
  setGalleryFileName,
  setGalleryId,
  setEditInitialValues,
  setModalAction,
  setShowModal,
  initialPreviewScreen,
  flag = true,
  imageContactData,
  setFilterContact,
  setRemoveGalleryIdContact,
  setShowImageEditor,
  userRole,
  setContactImages,
  editInitialValues,
}) => {
  const [activeAccordion, setActiveAccordion] = useState('');
  const [currentGalleryId, setCurrentGalleryId] = useState();
  const [singleImgModal, setSingleImgModal] = useState(false);

  const saveImageClick = useRef({});

  const handleClick = (data, name, id, index, row) => {
    if (index === activeAccordion) {
      setActiveAccordion('');
    } else {
      setActiveAccordion(index);
    }

    const test = hotFixCreateBlobUrl(data);
    setBlobURL((prevState) => ({ ...prevState, current: test, next: test }));
    setPreviewScreen &&
      setPreviewScreen((prevState) => ({
        ...prevState,
        image: data,
      }));
    setGalleryFileName && setGalleryFileName(name);
    setGalleryId && setGalleryId(id);
    setCurrentGalleryId(id);
    setSingleImgModal(true);

    saveImageClick.current = {
      galleryId: row?.galleryId,
      // name,
    };
  };

  useEffect(() => {
    if (flag) {
      galleryData.length === 0 &&
        fetchGalleryDetails(setGalleryData, setGalleryImages);
    }
  }, []);

  return (
    <>
      <Row>
        {galleryData.map((item, index) => (
          <Col
            key={index}
            md={3}
            lg={2}
            className={`ringer-gallery-main ${
              index === activeAccordion && 'active-img'
            }`}>
            <div className='ringer-gallery'>
              <img
                src={
                  galleryImages[item._id]
                    ? galleryImages[item._id]
                    : defaultGallery
                }
                onClick={(e) =>
                  galleryImages[item._id] &&
                  handleClick(
                    galleryImages[item._id],
                    item.avatar,
                    item._id,
                    index,
                    item
                  )
                }
              />
              <p>
                <span title={item.name}>
                  {item.name.length > 10
                    ? item.name.substring(0, 12) + '...'
                    : item.name}
                </span>
              </p>
              {member && userRole && userRole === 'Administrator' && (
                <div className='gal-remove-btn'>
                  <div className='d-flex action-btn action-btn-cs'>
                    <button
                      className='btn edit_btn text-black btn-sm'
                      onClick={() =>
                        editGallery(
                          setModalAction,
                          setEditInitialValues,
                          setPreviewScreen,
                          initialPreviewScreen,
                          setShowModal,
                          item,
                          imageContactData,
                          setFilterContact,
                          setRemoveGalleryIdContact
                        )
                      }>
                      <i className='fas fa-edit'></i>
                    </button>
                    <button
                      className='btn delete_btn text-black btn-sm'
                      onClick={() =>
                        removeGallery(
                          item._id,
                          setGalleryData,
                          galleryData,
                          imageContactData
                        )
                      }>
                      <i className='fas fa-trash'></i>
                    </button>
                  </div>
                </div>
              )}
            </div>
          </Col>
        ))}
      </Row>
      {!member && (
        <div className='w-100 text-end'>
          <button
            type='button'
            className='btn btn-primary text-end'
            onClick={(e) => {
              e.preventDefault();
              setShowGalleryModal && setShowGalleryModal(false);

              blobURL.current && setShowImageEditor && setShowImageEditor(true);

              setContactImages &&
                setContactImages((prevState) => ({
                  ...prevState,
                  [editInitialValues.id]: galleryImages[
                    saveImageClick.current?.galleryId
                  ]
                    ? galleryImages[saveImageClick.current.galleryId]
                    : defaultGallery,
                }));

              setEditInitialValues((preState) => ({
                ...preState,
                ...saveImageClick.current,
              }));

              // console.log('initialPreviewScreen', initialPreviewScreen);

              // editGallery(
              //   setModalAction,
              //   setEditInitialValues,
              //   setPreviewScreen,
              //   initialPreviewScreen ?? {},
              //   setShowModal,
              //   {
              //     ...saveImageClick.current,
              //   },
              //   imageContactData,
              //   setFilterContact,
              //   setRemoveGalleryIdContact
              // );

              // setEditInitialValues((prevState) => ({
              //   ...prevState,
              //   id: saveImageClick.current?._id,
              //   name: saveImageClick.current?.name,
              //   // contactId: test,
              // }));
            }}>
            Ok
          </button>
        </div>
      )}
      {member && singleImgModal && (
        <Lightbox
          small={galleryImages[currentGalleryId]}
          large={galleryImages[currentGalleryId]}
          hideDownload={true}
          hideZoom={true}
          onClose={() => setSingleImgModal(false)}
        />
      )}
    </>
  );
};

const mapStateToProps = ({ authReducer: { userRole } }) => ({
  userRole: userRole,
});

export default connect(mapStateToProps)(GalleryImage);
